import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=9c0fc14c&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=ts&"
export * from "./Notifications.vue?vue&type=script&lang=ts&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=9c0fc14c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0fc14c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c0fc14c')) {
      api.createRecord('9c0fc14c', component.options)
    } else {
      api.reload('9c0fc14c', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=9c0fc14c&scoped=true&", function () {
      api.rerender('9c0fc14c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drawer/Notifications.vue"
export default component.exports